// extracted by mini-css-extract-plugin
export var closeIcon = "style-mod--close-icon--85386";
export var header = "style-mod--header--6d84c";
export var noShadow = "style-mod--no-shadow--97a89";
export var opened = "style-mod--opened--f31aa";
export var panelContent = "style-mod--panel-content--b9534";
export var sidePanel = "style-mod--side-panel--0caae";
export var title = "style-mod--title--1889a";
export var toggleOverlay = "style-mod--toggle-overlay--1aab7";